import React from "react";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getAIDescriptionsAllStore from "../../../../stores/developer-store/ai-descriptions-all-store";

const AIGeneratedDescriptionAllForm = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getAIDescriptionsAllStore().getAllUsersAIDescriptions();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default AIGeneratedDescriptionAllForm;
